module.exports = __webpack_public_path__ + "static/media/10000d_p.9b3f3004.jpg";